import React from "react";
import { Banner } from "@shopify/polaris";

const CSV_UPLOAD_JOB_MESSAGE =
  "A CSV price upload is currently in progress. Please do not change product prices, markets, or other data until it completes, or you may encounter errors.";

const CsvUploadJobBanner = ({ isCsvUploadJobRunning }) => {
  if (!isCsvUploadJobRunning) {
    return null;
  }

  return (
    <div className="csv-upload-job-banner marketContactUsBanner">
      <Banner status="warning" title="CSV upload in progress">
        <p>{CSV_UPLOAD_JOB_MESSAGE}</p>
      </Banner>
    </div>
  );
};

export default CsvUploadJobBanner;
